<template>
  <v-container fluid class="grey lighten-3" grid-list-sm>
    <v-row>
      <v-col class="font-weight-black grey text-xs-center black--text py-1">
        <h3>آموزش</h3>
      </v-col>
    </v-row>
    <v-row wrap class="justify-center">
      <v-col cols="12" sm="6" md="3" pa-2 v-for="(item, idx) in items" :key="idx">
        <v-hover>
          <v-card height="100%" slot-scope="{ hover }" :class="`elevation-${hover ? 12 : 2}`" shaped>
            <v-card-title class="font-weight-black black--text justify-center word-break">{{ item.text }}</v-card-title>

            <v-responsive>
              <v-img :src="item.image" contain height="100px"></v-img>
            </v-responsive>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text color="grey darken-2" class="font-weight-thin black--text text-xs-center mb-0"
                :href="item.link" target="_blank">دانلود</v-btn>
            </v-card-actions>
          </v-card>
        </v-hover>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// import linksData from '/data/downloadlinksdata.json';
export default {
  name: "PazarTraining",
  computed: {
    items() {
      const linksData = this.$store.state.filesLinks;
      // console.info(linksData)
      let links = {}
      // links = {
      //   pazarcatalog: {
      //     image: require("@/assets/img/Downloads/pazar-catalog.jpg"),
      //     text: "کاتالوگ نرم افزار پازار",
      //     link: "",
      //   },
      //   pazarfordummies: {
      //     image: require("@/assets/img/Downloads/pazar-amozesh.jpg"),
      //     text: "آموزش نرم افزار پازار",
      //     link: "",
      //   },
      //   howtosetuppazar: {
      //     image: require("@/assets/img/Downloads/pazar-amozesh-install.jpg"),
      //     text: "راهنمای نصب نرم افزار پازار",
      //     link: "",
      //   },
      //   howtoupdatepazarplus: {
      //     image: require("@/assets/img/Downloads/cd-verplus.jpg"),
      //     text: "راهنمای آپدیت پازارپلاس",
      //     link: "",
      //   },
      //   howtocreatenewyearpazarplus: {
      //     image: require("@/assets/img/Downloads/cd-verplus.jpg"),
      //     text: "راهنمای ایجاد سال مالی جدید و نقل مانده در نرم افزار پازارپلاس",
      //     link: "",
      //   },
      // };
      // for (let index = 0; index < linksData.length; index++) {
      //   const element = linksData[index];
      //   if (element.Name.trim().toLowerCase() === "pazarcatalog") {
      //     links.pazarcatalog.link = element.Link;
      //   }
      //   if (element.Name.trim().toLowerCase() === "pazarfordummies") {
      //     links.pazarfordummies.link = element.Link;
      //   }
      //   if (element.Name.trim().toLowerCase() === "howtosetuppazar") {
      //     links.howtosetuppazar.link = element.Link;
      //   }
      //   if (element.Name.trim().toLowerCase() === "howtoupdatepazarplus") {
      //     links.howtoupdatepazarplus.link = element.Link;
      //   }
      //   if (element.Name.trim().toLowerCase() === "howtocreatenewyearpazarplus") {
      //     links.howtocreatenewyearpazarplus.link = element.Link;
      //   }
      // }
      // --
      for (let index = 0; index < linksData.length; index++) {
        const element = linksData[index];
        if (element.CategoryId == 1) {
          links[`index${index}`] = { text: element.Caption, link: element.Link, image: element.ImageLink }
        }
      }
      return links;
    },
  },
};
</script>

<style>
.word-break {
  /* background-color: rgba(0, 0, 0, 0.644);
  white-space: pre; */
  word-break: break-word;
}
</style>
